const actions = {
  GET_CPH_DATA: 'GET_CPH_DATA',
  GET_CPH_DATA_SUCCESS: 'GET_CPH_DATA_SUCCESS',
  GET_CPH_DATA_FAILED: 'GET_CPH_DATA_FAILED',
  GET_CPHDETAIL_DATA: 'GET_CPHDETAIL_DATA',
  GET_CPHDETAIL_DATA_SUCCESS: 'GET_CPHDETAIL_DATA_SUCCESS',
  GET_CPHDETAIL_DATA_FAILED: 'GET_CPHDETAIL_DATA_FAILED',


  getCphData: (offset, limit, search, fromDate, toDate , agentId) => ({
    type: actions.GET_CPH_DATA,
    payload: { offset, limit, search, fromDate, toDate , agentId },
  }),
  getCphDataSuccess: (data, totalData) => ({
    type: actions.GET_CPH_DATA_SUCCESS,
    payload: { data, totalData },
  }),
  getCphDataFailed: (error) => ({
    type: actions.GET_CPH_DATA_FAILED,
    payload: { error },
  }),
  getCphDetailData: (mobileNumber ,offset, limit, search, fromDate, toDate , agentId) => ({
    type: actions.GET_CPHDETAIL_DATA,
    payload: { mobileNumber,offset, limit, search, fromDate, toDate , agentId},
  }),
  getCphDetailDataSuccess: (data, totalData) => ({
    type: actions.GET_CPHDETAIL_DATA_SUCCESS,
    payload: { data, totalData },
  }),
  getCphDetailDataFailed: (error) => ({
    type: actions.GET_CPHDETAIL_DATA_FAILED,
    payload: { error },
  }),

};

export default actions;
